module.exports = "<p>\n  chooser works!\n</p>\n"